import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { FormService } from "src/app/services/form.service";
import { BusinessProposalService } from "src/app/services/business-proposal.service";
import { SectionTogglerComponent } from "../../layout/section-toggler/section-toggler.component";
import { ShowProposalPpsPackagesComponent } from "../show-proposal-pps-packages/show-proposal-pps-packages.component";

@Component({
  selector: "app-specs-pps-section",
  templateUrl: "./specs-pps-section.component.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SectionTogglerComponent,
    ReactiveFormsModule,
    ShowProposalPpsPackagesComponent,
    TranslateModule
  ]
})
export class SpecsPpsSectionComponent {
  toggle = signal(false);

  constructor(
    public formService: FormService,
    public businessProposalService: BusinessProposalService
  ) {}
}
